import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _div;
import { useState } from "react";
import Observer from "@researchgate/react-intersection-observer";
import { jsx as _jsx } from "react/jsx-runtime";
var Lazyload = function Lazyload(_ref) {
  var children = _ref.children,
    style = _ref.style,
    placeholder = _ref.placeholder,
    observerOptions = _ref.observerOptions,
    wrapperClassName = _ref.wrapperClassName,
    onVisible = _ref.onVisible;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisbile = _useState2[0],
    setIsVisible = _useState2[1];
  var handleIntersection = function handleIntersection(event) {
    var isIntersecting = event.isIntersecting;
    if (isIntersecting) {
      setIsVisible(true);
      if (onVisible) {
        onVisible();
      }
    }
  };
  var options = {
    onChange: handleIntersection,
    rootMargin: '0px 0px 300px 0px',
    disabled: isVisbile
  };
  return /*#__PURE__*/_jsx(Observer, _objectSpread(_objectSpread(_objectSpread({}, options), observerOptions), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: wrapperClassName,
      style: _objectSpread({}, style),
      children: isVisbile ? children : placeholder || _div || (_div = /*#__PURE__*/_jsx("div", {}))
    })
  }));
};
export default Lazyload;